import { GetTraitFeedback, GetTraitLlmFeedback } from "../../../app/writingAnalysis";
import { WritingAnalysisViewModel } from "../../scoreReport/scoreReportApiSlice";
import { TraitScore } from "./TraitScore";
import { TraitFeedback } from "./TraitFeedback";
import { TraitLlmFeedback } from "./TraitLlmFeedback";
import { TraitTutorials } from "./TraitTutorials";

export interface Props {
	className?: string;
	analysis?: WritingAnalysisViewModel;
}

export default function WritingAnalysis(props: Props) {
	if (!props.analysis) return null;
	return (
		<>
			<h1 className={props.className}>Writing Analysis</h1>
			{props.analysis.categories
				.filter((trait) => trait.score)
				.map((trait) => {
					const feedback = GetTraitFeedback(props.analysis, trait);
					const llmFeedback = GetTraitLlmFeedback(props.analysis, trait);
					return (
						props.analysis && (
							<section key={trait.id}>
								<h2 className="mt-6">{trait.name}</h2>
								<TraitScore
									score={trait.score!}
									maxScore={trait.maxScore}
									visible={props.analysis.showScore}
									oneline={true}
								/>
								<TraitLlmFeedback
									className="mt-4 mr-4"
									heading="Writing Advisor"
									traitId={trait.id}
									llmFeedbackId={props.analysis.llmFeedback?.id}
									llmFeedback={llmFeedback}
									showCommentButton={false}
								/>
								<TraitFeedback
									className="mt-4"
									heading="Evaluation and Feedback"
									feedback={feedback}
									isProctorScored={trait.isProctorScored}
								/>
								<TraitTutorials
									className="mt-4"
									heading="Lessons"
									tutorials={props.analysis.feedbackTutorials[trait.id]}
								/>
							</section>
						)
					);
				})}
		</>
	);
}
